export const submenuMyAccount = [
  {
    value: 'profile',
    link: '/myAccount/profile',
    text: 'Mi Perfil'
  },
  {
    value: 'password',
    link: '/myAccount/password',
    text: 'Mi Contraseña'
  },
  {
    value: 'aditionalInfo',
    link: '/myAccount/aditionalInfo',
    text: 'Información Adicional'
  }
];
